var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislike1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    width: 26,
    height: 25,
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0, 0, 0)"
    },
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.01 25c-.5 0-1.03-.15-1.6-.43a3.4 3.4 0 0 1-1.64-1.82c-.32-.84-.58-1.7-.78-2.57-.36-1.58-1.66-4.1-2.94-5.19-.7-.59-1.1-1.49-1.1-2.46V5.05c0-.86.29-1.72.83-2.39C9.04 1.04 10.18.17 11.15.08c1.59-.16 7.45-.01 7.88 0 .24 0 1.55.04 2.31 1.42.6 1.1 3.81 6.83 3.94 7.08.37.66.6 1.37.67 2.09.11 1.04.06 2.49-.83 3.52-.62.73-1.53 1.12-2.72 1.17-3.09.13-4.78.06-5.35.02.11.72.37 2.51.75 5.36.11.83 0 1.66-.32 2.39-.39.88-.96 1.48-1.66 1.73-.26.09-.54.14-.81.14ZM4.33 15.13H1.58C.7 15.13 0 14.41 0 13.54V3.33c0-.88.7-1.59 1.58-1.6h2.74c.88 0 1.58.72 1.58 1.6v10.21c0 .88-.71 1.6-1.57 1.59Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(255, 255, 255)"
    },
    className: "fills"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    width: 26,
    height: 25,
    style: {
      fill: "none",
      strokeWidth: 0
    },
    className: "fills"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.01 25c-.5 0-1.03-.15-1.6-.43a3.4 3.4 0 0 1-1.64-1.82c-.32-.84-.58-1.7-.78-2.57-.36-1.58-1.66-4.1-2.94-5.19-.7-.59-1.1-1.49-1.1-2.46V5.05c0-.86.29-1.72.83-2.39C9.04 1.04 10.18.17 11.15.08c1.59-.16 7.45-.01 7.88 0 .24 0 1.55.04 2.31 1.42.6 1.1 3.81 6.83 3.94 7.08.37.66.6 1.37.67 2.09.11 1.04.06 2.49-.83 3.52-.62.73-1.53 1.12-2.72 1.17-3.09.13-4.78.06-5.35.02.11.72.37 2.51.75 5.36.11.83 0 1.66-.32 2.39-.39.88-.96 1.48-1.66 1.73-.26.09-.54.14-.81.14ZM13.93 1.28c-1.13 0-2.14.02-2.65.07-.58.06-1.52.84-2.5 2.1-.36.46-.55 1.02-.56 1.6v7.48c0 .59.24 1.13.65 1.48 1.5 1.27 2.95 4.07 3.36 5.89.23 1 .52 1.85.73 2.39.19.5.55.9 1.02 1.13.57.29 1.04.36 1.42.23.37-.13.68-.48.92-1.04.22-.51.3-1.1.22-1.69-.52-3.81-.74-5.37-.78-5.56a.928.928 0 0 1 .13-.76c.27-.4.77-.49.92-.51h.14s1.68.16 5.4 0c.82-.03 1.43-.28 1.81-.73.58-.69.61-1.77.53-2.55-.06-.56-.24-1.1-.52-1.6-.14-.24-3.34-5.99-3.94-7.09-.42-.76-1.09-.76-1.17-.76h-.05s-2.81-.07-5.08-.08Zm-9.6 13.85H1.58C.7 15.13 0 14.41 0 13.54V3.33c0-.88.7-1.59 1.58-1.6h2.74c.88 0 1.58.72 1.58 1.6v10.21c0 .88-.71 1.6-1.57 1.59ZM1.58 3.02c-.17 0-.31.14-.31.31v10.21c0 .17.14.31.31.31h2.74c.17 0 .31-.14.31-.31V3.33c0-.17-.14-.31-.31-.31H1.58Z",
    style: {
      strokeWidth: 0,
      fill: "rgb(29, 29, 27)"
    },
    className: "fills"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike1);
export default __webpack_public_path__ + "static/media/dislike_1.b4724ee9266aa2b3ee9fa89d614a9f98.svg";
export { ForwardRef as ReactComponent };